// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13909035","453":"bea66239","455":"59b6bbbe"}[chunkId] + ".chunk.js";
};